import {ErrorFilter} from './error-filter';

export class RunAnalysisRequest {
  botId: number;
  tdeIds: number[];

  constructor(botId: number, tdeIds: number[]) {
    this.botId = botId;
    this.tdeIds = tdeIds;
  }
}
